import { render, staticRenderFns } from "./AppComment.vue?vue&type=template&id=1ccf6d53&scoped=true&"
import script from "./AppComment.vue?vue&type=script&lang=js&"
export * from "./AppComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccf6d53",
  null
  
)

export default component.exports